import { base } from '@modules';

import { DeploymentsByProgramSchema } from './DeploymentsByProgram.schema';

export const initialState: DeploymentsByProgramSchema = {
  ...base.state,
  data: [],
};
